import React from "react";
import {
  ShimmerButton,
  ShimmerCategoryItem,
  ShimmerCircularImage,
  ShimmerSectionHeader,
  ShimmerSimpleGallery,
  ShimmerText,
  ShimmerThumbnail,
} from "react-shimmer-effects";

const ExperienceOfferedShimmer = () => {
  return (
    <div className="shimmer-container d-flex flex-column gap-3">
      <ShimmerSimpleGallery
        card
        imageHeight={60}
        row={2}
        col={1}
        gap={10}
        caption
      />

      <div className="d-flex align-items-center justify-content-between mt-4">
        <ShimmerButton size="md" />
        <ShimmerButton size="md" />
      </div>
    </div>
  );
};

export default ExperienceOfferedShimmer;
